/*********notification slice**************/

import { createSlice } from "@reduxjs/toolkit";

const loadStateFromLocalStorage = () => {
  const savedState = localStorage.getItem('alertsState');
  if (savedState) {
    return JSON.parse(savedState);
  }
  return {
    notifications: [],
    closedAlerts: [],
  };
};

const initialState = loadStateFromLocalStorage();

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addNotification: (state, action) => {
      state.notifications.push(action.payload);
      saveStateToLocalStorage(state);
    },
    closeSelectedAlerts: (state, action) => {
      const selectedIds = action.payload;
      const selectedAlerts = state.notifications.filter(alert =>
        selectedIds.includes(alert.alert_id)
      );

      state.notifications = state.notifications.filter(alert =>
        !selectedIds.includes(alert.alert_id)
      );

      state.closedAlerts.push(...selectedAlerts);
      saveStateToLocalStorage(state);
    },
    deleteClosedAlert: (state, action) => {
      const alertId = action.payload;
      state.closedAlerts = state.closedAlerts.filter(alert => alert.alert_id !== alertId);
      saveStateToLocalStorage(state);
    },
    toggleAlertReadStatus: (state, action) => {
      const alertId = action.payload;
      const alert = state.notifications.find(alert => alert.alert_id === alertId);
      if (alert) {
        alert.read = !alert.read;
      }
      saveStateToLocalStorage(state);
    },
  },
});

export const selectUnreadCount = (state) =>
  state.notifications.notifications.length;
  // state.notifications.notifications.filter(alert => !alert.read).length;

const saveStateToLocalStorage = (state) => {
  localStorage.setItem('alertsState', JSON.stringify(state));
};

export const { addNotification, closeSelectedAlerts, deleteClosedAlert, toggleAlertReadStatus } = notificationsSlice.actions;
export default notificationsSlice.reducer;
